"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PepScreeningDescription = void 0;
const Field_type_1 = require("../../../types/Field.type");
exports.PepScreeningDescription = {
    priority: 2,
    label: 'fields.payload.mor_group_answers.pep_screening_description.label',
    fallbackLabel: 'Please explain how does the institution manage the risks associated with Politically Exposed Persons (PEPs) if PEP screening is not conducted, and what is the rationale for not implementing such screening?',
    mandatory: (payload, path) => isMandatory(payload, path),
    disabled: (payload, path) => false,
    applicable: (payload, path) => isApplicable(payload, path),
    applicableDependsOn: ['mor_group_answers.has_pep_screening', 'contract_onboarding_type'],
    type: Field_type_1.FieldType.String,
    trackFieldValueWithAnalytics: false,
};
function isMandatory(payload, path) {
    return payload.mor_group_answers?.has_pep_screening === false
        && (payload.contract_onboarding_type?.valueOf?.() === 'MOR_ONBOARDING_GROUP');
}
function isApplicable(payload, path) {
    return payload.mor_group_answers?.has_pep_screening === false
        && (payload.contract_onboarding_type?.valueOf?.() === 'MOR_ONBOARDING_GROUP');
}
